const sparkLineData = {
    over90: { data: [], metrics: {}, format: '###.00 "%"' },
    underbillings: { data: [], metrics: {}, format: '###.00 "%"' },
    overbillings: { data: [], metrics: {}, format: '###.00 "%"' },
    retention: { data: [], metrics: {}, format: '###.00 "%"' },
    unapprovedAp: { data: [], metrics: {}, format: 'c0' },
    unapprovedApKpi: { data: {}, metrics: {}, format: 'c0' }
};

let columnsGenerated = false;
const columnData = [];
const chartColumnData = [];

function getValues(data, type) {
    if (type !== 'read') return data;
    const sourceName = 'all';
    const company =
        $('#viewLevel').val() ||
        $('#changeCompany--js')
            .find('a.menu-settings__link--active')
            .attr('data-value');
    const timePeriod = $('#timePeriod').val() || 1;
    const division = $('#division').val() || '';
    const send = { sourceName, company, timePeriod, division };
    return $.extend(send, data);
}

function onMetricRequestEnd(arg) {
    if (arg.type === 'read' && arg.response !== undefined && arg.response.length > 0) {
        arg.response.forEach(function(row) {
            const that = {};
            Object.assign(that, row);
            const measureName = that.mName.trim();
            delete that.mName;
            delete that.mid;
            let metricSource;
            if (measureName === 'AR Over 90') metricSource = sparkLineData.over90.metrics;
            if (measureName === 'Underbillings') metricSource = sparkLineData.underbillings.metrics;
            if (measureName === 'Overbillings') metricSource = sparkLineData.overbillings.metrics;
            if (measureName === 'Retention') metricSource = sparkLineData.retention.metrics;
            if (measureName === 'Unapproved AP') {
                metricSource = sparkLineData.unapprovedAp.metrics;
                const kpiVal = { current: that[0], target: 0 }; // set values for the bullet chart;  current, target
                Object.assign(sparkLineData.unapprovedApKpi.metrics, kpiVal);
            }
            if (metricSource == undefined) return;
            while (metricSource.length > 0) metricSource.pop();
            Object.assign(metricSource, that);
        });
    }
}

const metricDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Account/Scorecard/GetFinanceMetrics',
            dataType: 'json'
        },
        parameterMap: getValues
    },
    requestEnd: onMetricRequestEnd
});

function setLoading() {
    const sparklines = $('.sparkline');
    sparklines.each(function() {
        const that = $(this);
        const $el = that.closest('.collapsible--sparkline.--fade-in');
        $el.removeClass('--js-data-bound');
        $el.removeClass('--show');
    });
}

function onGridRequestStart(arg) {
    if (arg.type === 'read') {
        metricDataSource.read();
        $('#scorecardLoading').toggle(true);
        setLoading();
    }
}

function updateTags(that) {
    const parent = $(that.element).parents('.card');
    const thatTag = parent.find('.tag');
    thatTag.removeClass('tag--red tag--yellow tag--green');
    const sparklineName = that.element[0].id;
    const chartData = that.options.data || [];
    let chart = {};
    if (sparklineName === 'sparklineConstructionArOver90') chart = sparkLineData.over90;
    if (sparklineName === 'sparklineUnderbillings') chart = sparkLineData.underbillings;
    if (sparklineName === 'sparklineOverbillings') chart = sparkLineData.overbillings;
    if (sparklineName === 'sparklineRetention') chart = sparkLineData.retention;
    if (sparklineName === 'sparklineAmountOfUnapprovedInvoicesInQueue') chart = sparkLineData.unapprovedAp;
    const lastVal = chartData[chartData.length - 1] || String.fromCharCode(160);
    thatTag.text(kendo.toString(lastVal, chart.format));
    if (chart.metrics === undefined) return;
    const { redHigh, redLow, yellowHigh, yellowLow, greenHigh, greenLow } = chart.metrics;
    if (lastVal <= redHigh && lastVal >= redLow) thatTag.addClass('tag--red');
    if (lastVal <= yellowHigh && lastVal >= yellowLow) thatTag.addClass('tag--yellow');
    if (lastVal <= greenHigh && lastVal >= greenLow) thatTag.addClass('tag--green');
}

function refreshSparklines() {
    $('[data-role="sparkline"]').each(function() {
        const that = $(this).data('kendoSparkline') || $(this).data('kendoDollarValue');
        that.refresh();
        updateTags(that);
    });
}

function onGridRequestEnd(arg) {
    if (arg.type === 'read' && arg.response.length > 0) {
        columnsGenerated = false;
        arg.response.forEach(function(row) {
            const that = {};
            Object.assign(that, row);
            const measureName = that.measure;
            Object.keys(that).forEach(function(key) {
                if (key === 'measure') delete that.measure;
                if (key === 'mDesc') delete that.mDesc;
                if (key.endsWith('_status')) delete that[key];
            });

            let measure;
            if (measureName === 'AR Over 90') measure = sparkLineData.over90;
            if (measureName === 'Underbillings') measure = sparkLineData.underbillings;
            if (measureName === 'Overbillings') measure = sparkLineData.overbillings;
            if (measureName === 'Retention') measure = sparkLineData.retention;
            if (measureName === 'Unapproved AP') measure = sparkLineData.unapprovedAp;

            if (!columnsGenerated) {
                columnData.splice(0, columnData.length);
                const measureColumn = {};
                measureColumn.field = 'measure';
                measureColumn.title = '&nbsp;';
                measureColumn.locked = true;
                measureColumn.width = 180;
                measureColumn.template = function(dataItem) {
                    return `
                        <button class="flex flex-no-wrap items-center scorecard__popup-toggle"> 
                            <span class="k-icon k-i-more-vertical k-icon-sm"></span>
                            <span>${kendo.htmlEncode(dataItem.measure)}</span>
                        </button>
                        <span class="scorecard__popup-content popup measure">
                            <p><strong>${kendo.htmlEncode(dataItem.measure)}</strong></p>
                            ${dataItem.mDesc}
                        </span>
                    `;
                };
                columnData.push(measureColumn);
                Object.keys(that).forEach(function(key) {
                    const keyStatus = `${key}_status`;
                    const column = {};
                    column.field = key;
                    column.title = key;
                    column.width = 100;
                    column.attributes = { style: '' };
                    column.template = dataItem => {
                        if (dataItem[keyStatus] === null) {
                            return `<span class="grid-cell--status" data-status="${kendo.htmlEncode(
                                dataItem[keyStatus]
                            )}"><span class="k-icon k-i-minus"></span></span>`;
                        }
                        let frmt;
                        if (dataItem.measure === 'AR Over 90') frmt = sparkLineData.over90.format;
                        if (dataItem.measure === 'Underbillings') frmt = sparkLineData.underbillings.format;
                        if (dataItem.measure === 'Overbillings') frmt = sparkLineData.overbillings.format;
                        if (dataItem.measure === 'Retention') frmt = sparkLineData.retention.format;
                        if (dataItem.measure === 'Unapproved AP') frmt = sparkLineData.unapprovedAp.format;
                        const value = kendo.toString(dataItem[key], frmt);
                        return `<span class="grid-cell--status" data-status="${kendo.htmlEncode(dataItem[keyStatus])}">${value}</span>`;
                    };
                    columnData.push(column);
                });
                columnsGenerated = true;
            }

            const data = [];
            Object.keys(that).forEach(function(key) {
                data.push(that[key]);
            });
            const dataSource = measure.data;
            if (measureName === 'Unapproved AP') {
                const lastIndex = data.length - 1;
                const kpiVal = { current: data[lastIndex], target: 0 }; // set values for the bullet chart;  current, target
                Object.assign(sparkLineData.unapprovedApKpi.data, kpiVal);
            }
            while (dataSource !== undefined && dataSource.length > 0) dataSource.pop();
            Object.assign(dataSource, data);
        });
        refreshSparklines();
        $('#scorecardLoading').toggle(false);
    }
}

const gridDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Account/Scorecard/GetFinanceData',
            dataType: 'json'
        },
        parameterMap: getValues
    },
    requestStart: onGridRequestStart,
    requestEnd: onGridRequestEnd
});

export { sparkLineData };
export { gridDataSource };
export { columnData };
export { chartColumnData };
